var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCleanBeeClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.585787 0.585787C1.36684 -0.195262 2.63317 -0.195262 3.41421 0.585787L14 11.1716L24.5858 0.585787C25.3668 -0.195262 26.6332 -0.195262 27.4142 0.585787C28.1953 1.36684 28.1953 2.63317 27.4142 3.41421L16.8284 14L27.4142 24.5858C28.1953 25.3668 28.1953 26.6332 27.4142 27.4142C26.6332 28.1953 25.3668 28.1953 24.5858 27.4142L14 16.8284L3.41421 27.4142C2.63317 28.1953 1.36684 28.1953 0.585787 27.4142C-0.195262 26.6332 -0.195262 25.3668 0.585787 24.5858L11.1716 14L0.585787 3.41421C-0.195262 2.63317 -0.195262 1.36684 0.585787 0.585787Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleanBeeClose);
export default __webpack_public_path__ + "static/media/cleanBee_close.2b06a40693878318d027ad7f8b62161d.svg";
export { ForwardRef as ReactComponent };